import { t } from '@deltasierra/shared';
import { Box, Checkbox, Collapse } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import * as React from 'react';

export type ToggleCollapseProps = {
    children?: React.ReactNode;
    handleSetOpen: () => void;
    isDisabled?: boolean;
    isOpen: boolean;
    onClickTitle?: () => void;
    title: React.ReactNode;
};

export const ToggleCollapse = ({
    children,
    handleSetOpen,
    isDisabled,
    isOpen,
    onClickTitle,
    title,
}: ToggleCollapseProps): JSX.Element => {
    if (isDisabled) {
        return (
            <Box sx={{ width: '100%' }}>
                {title}
                {children}
            </Box>
        );
    }
    return (
        <Box sx={{ width: '100%' }}>
            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                }}
                onClick={onClickTitle}
            >
                {title}
                <Checkbox
                    checked={isOpen}
                    checkedIcon={<ArrowDropDownIcon />}
                    icon={<ArrowDropDownIcon style={{ rotate: '270deg' }} />}
                    inputProps={{
                        'aria-label': t('COMPONENTS.TOGGLE_COLLAPSE_CHECKBOX'),
                    }}
                    onClick={event => {
                        event.stopPropagation();
                        handleSetOpen();
                    }}
                />
            </Box>
            <Collapse in={isOpen}>{children}</Collapse>
        </Box>
    );
};

ToggleCollapse.displayName = 'ToggleCollapse';
